




























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class storeApplet extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    startDate: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    endDate: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    skip: 0,
    count: 10,
  };
  /**列表选项 */
  selectTable = [];
  exloading = false;
  total1 = 0;
  total2 = "0.0";
  total3 = "-0";
  total4 = "-0.00";
  total5 = "0.00";
  total6 = 0;
  total7 = "0.00";
  total8 = "0.00";
  total9 = "0.00";
  async mounted() {
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    await this.getlist();
    await this.gettotal();
    // handleEnter(this.handleSearch)
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetTransactionOverview(this.searchValue);
    this.listData = result.item2.map((v) => {
      return {
        ...v,
        returnCount: v.returnCount ? "-" + v.returnCount : "-0",
        returnAmount: v.returnAmount ? "-" + fmoney(v.returnAmount) : "-0.00",
      };
    });
    this.total = result.item1;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  public async gettotal() {
    this.loading = true;
    let result = await Public.GetTransactionOverviewTotal(this.searchValue);
    this.total1 = result.orderCount ? result.orderCount : 0;
    this.total2 = result.orderAmount ? fmoney(result.orderAmount) : "0.00";
    this.total3 = result.returnCount ? "-" + result.returnCount : "-0";
    this.total4 = result.returnAmount ? "-" + fmoney(result.returnAmount) : "-0.00";
    this.total5 = result.actualAmount ? fmoney(result.actualAmount) : "0.00";
    this.total6 = result.rechargeCount ? result.rechargeCount : 0;
    this.total7 = result.rechargeAmount ? fmoney(result.rechargeAmount) : "0.00";
    this.total8 = result.giftAmount ? fmoney(result.giftAmount) : "0.00";
    this.total9 = result.subtotal ? fmoney(result.subtotal) : "0.00";
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计";
    sums[1] = this.total1;
    sums[2] = this.total2;
    sums[3] = this.total3;
    sums[4] = this.total4;
    sums[5] = this.total5;
    sums[6] = this.total6;
    sums[7] = this.total7;
    sums[8] = this.total8;
    sums[9] = this.total9;
    return sums;
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      startDate: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
      endDate: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
      skip: 0,
      count: 10,
    };
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  //   /**查看详情 */
  //   viewRow(id) {
  //     this.$router.push(`./storeAppletDetail?id=${id}&name=detail`);
  //   }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.startDate = val[0] + " 00:00:00";
      this.searchValue.endDate = val[1] + " 23:59:59";
    } else {
      this.searchValue.startDate = "";
      this.searchValue.endDate = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.TransactionOverviewExport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        // let blob = new Blob([res]);
        // var objectUrl = URL.createObjectURL(blob);
        // var fileName = objectUrl.substring(objectUrl.lastIndexOf("/") + 1);
        var fileName = "门店交易总览报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/shopJYZL/index.vue